<template>
    <div class="videoView" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div 
            class="video-container" 
            :class="{'border-radius': item.bgStyle && item.bgStyle.type === 1}"
        >
            <div class="video-wrapper" :style="wrapperStyle">
                <img 
                    class="video-image" 
                    :src="item.bannerConfig.url ? item.bannerConfig.url : 'SERVER_API/images/decoration/videoplay.png'"
                    :style="imageStyle"
                />
                <div class="play">
                    <svg viewBox="0 0 24 24" class="play-icon">
                        <path d="M8 6 L18 12 L8 18 Z" fill="currentColor" stroke="currentColor" stroke-width="0.8" stroke-linejoin="round" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
        </div>
<!--        <video></video>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    computed: {
        // 计算宽高比对应的 padding-bottom 百分比
        aspectRatio() {
            if (!this.item.scaleStyle || !this.item.scaleStyle.list) {
                return '56.25%'; // 默认 16:9
            }
            
            const type = this.item.scaleStyle.type || 0;
            const ratio = this.item.scaleStyle.list[type]?.val || '16:9';
            
            // 解析比例字符串，如 "16:9" -> 9/16 = 0.5625 = 56.25%
            const [width, height] = ratio.split(':').map(Number);
            if (width && height) {
                return `${(height / width) * 100}%`;
            }
            
            return '56.25%'; // 默认 16:9
        },
        
        // 包装器样式（控制宽高比）
        wrapperStyle() {
            return {
                paddingBottom: this.aspectRatio
            };
        },
        
        // 图片样式
        imageStyle() {
            return {
                objectFit: 'cover' // 覆盖整个容器，保持比例
            };
        },
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.videoView {
    .video-container {
        width: 100%;
        position: relative;
        overflow: hidden;
        
        &.border-radius {
            border-radius: 6px;
        }
        
        .video-wrapper {
            position: relative;
            width: 100%;
            height: 0;
            overflow: hidden;
            
            .video-image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: block;
            }
            
            .play {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 60px;
                height: 60px;
                background-color: rgba(0, 0, 0, 0.6); // 改回之前的背景色
                border: 2px solid rgba(255, 255, 255, 0.5); // 淡色边框
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease;
                z-index: 10;
                display: flex;
                align-items: center;
                justify-content: center;
                
                .play-icon {
                    width: 42px; // 继续增大三角形大小
                    height: 42px;
                    color: rgba(255, 255, 255, 0.5); // 和边框颜色一样
                    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.3));
                    
                    path {
                        // 使用 SVG 的圆角效果
                        stroke: rgba(255, 255, 255, 0.5); // 和边框颜色一样
                        stroke-width: 0.5;
                        stroke-linejoin: round; // 圆滑的角
                        stroke-linecap: round;
                    }
                }
                
                //&:hover {
                //    background-color: rgba(0, 0, 0, 0.8);
                //    border-color: rgba(255, 255, 255, 0.7);
                //    transform: translate(-50%, -50%) scale(1.1);
                //
                //    .play-icon {
                //        color: rgba(255, 255, 255, 1);
                //    }
                //}
                
                &:active {
                    transform: translate(-50%, -50%) scale(0.95);
                }
            }
        }
    }
}
</style>